import { render, staticRenderFns } from "./consignmentAction.vue?vue&type=template&id=a43d4ca2&scoped=true"
import script from "./consignmentAction.vue?vue&type=script&lang=js"
export * from "./consignmentAction.vue?vue&type=script&lang=js"
import style0 from "./consignmentAction.vue?vue&type=style&index=0&id=a43d4ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43d4ca2",
  null
  
)

export default component.exports